<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
  Opret bruger
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Vælg invitationstype</mat-label>
      <mat-select [formControl]="selectedType" placeholder="Vælg en mulighed..." okCustomDropDownArrowDirective>
        <mat-option value="app-invitation">Med invitation til OK-app</mat-option>
        <mat-option value="idtag-with-invitation">Med brik, med invitation</mat-option>
        <mat-option value="idtag-without-invitation">Med brik, uden invitation</mat-option>
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
